<template>
    <div class="container">
        <div class="content" >
            <div class="data-title">
                <div style="display: flex;height: 32px;">
                    <div class="title-line"></div>
                    <div class="title-name">更新记录</div>
                </div>

                <div class="title-btn">
                    <div class="title-btn-item" @click="openAdiog">
                        <i class="el-icon-plus"></i>
                        <div class="btn-l">新增热更新</div>
                    </div>
                </div>
            </div>
            <lb-table :column="column" :data="tableList" pagination :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                :current-page.sync="page.currentPage" :page-size="page.pageSize" @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
            </lb-table>
        </div>

        <!-- ============================= el-dialog ============================= -->


        <el-dialog :visible.sync="dialogFormVisible" :append-to-body="true" title="新增热更新" width="600px" class="update-app">
            <el-form :model="form" :rules="rules" ref="form" size="small" class="elForm">
                <el-form-item label-width="100px" label="版本号" prop="version">
                    <el-input maxlength="6" v-model="form.version" placeholder="请输入版本号,例如：1.0.01" size="small" style="width: 360px;"></el-input>
                </el-form-item>
                <el-form-item label-width="100px" label="热更包" prop="wgtUrl" class="upload-file-con">
                    <upload-file :limit="1" suffix=".wgt" @getUrl="getUrl" :file-list="fileList" ></upload-file>
                </el-form-item>
                <el-form-item label-width="100px" label="更新内容" prop="updateTips">
                    <el-input
                        style="width: 360px;"
                        maxlength="128"
                        :rows="4"
                        show-word-limit
                        type="textarea"
                        v-model="form.updateTips"
                        placeholder="请输入更新内容"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" :loading="btnloading" @click="updateOk">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import LbTable from '../../components/lb-table/lb-table'
import uploadFile from '../../components/fileUpload.vue'
export default {
    name: 'role',
    components: {
        LbTable,
        uploadFile
    },
    data() {
        return {
            column: [
                {
                    type: 'index',
                    label: '序号',
                    width: 80,
                },
                {
                    label: '更新时间',
                    prop: 'updatedTime',
                      width: 170
                },
                {
                    label: '版本号(热更)',
                    prop: 'versionAndroids',
                    minWidth: 170
                },
                {
                    label: '更新内容',
                    prop: 'updateTips',
                    minWidth: 170,
                    render: (h, scope) => {
                        return (
                            <div style="text-align:left">{scope.row.updateTips}</div>
                        )
                    }
                },
            //     {
            //     label: '操作',
            //     width: 160,
            //     fixed:"right",
            //     render: (h, scope) => {
            //         return (
            //             <div style="display:flex;justify-content:center">
                            
            //                     <div
            //                         style="color:#f40713;cursor:pointer;"
            //                         onClick={() => {
            //                             this.onDelete(scope.row);
            //                         }}>删除
            //                     </div>
                            
            //             </div>
            //         )
            //     }
            // }
                ],

            rules: {
                version: [
                    { required: true, message: '请输入版本号', trigger: ['blur','change'] },
                    { pattern: /^\d+\.\d+\.\d{2}$/, message: '版本号格式应为x.x.xx', trigger: ['blur'] }
                ],
                 wgtUrl: [
                    { required: true, message: '请上传热更包', trigger: 'blur' }
                ],
                 updateTips: [
                    { required: true, message: '请输入更新说明', trigger:  ['blur','change'] }
                ],
            },
            tableList:[],
            page: {
                pageNo: 1,
                pageSize: 10,
                totalNum: 0,
                currentPage: 1,
            },

            parArray: [], // 按钮权限
            dialogFormVisible: false,
            btnloading: false,
            form: {
                version: "",
                wgtUrl: "",
                updateTips:""
            },
            fileList:[]
        };
    },
    created() {
        // this.getButtonTreeDto() // 获取权限设定
        this.fetchData()

        // 权限设定判断 normsCode
        // this.limits = JSON.parse(sessionStorage.getItem("limit"));
        // const params = this.limits.buttonTreeDto.filter(
        //     (item) => item.menuCode === "role"
        // );
        // params[0].buttonList.forEach((item) => {
        //     this.parArray.push(item.code);
        // });
        // 权限设定判断 normsCode
    },
    methods: {

        // getButtonTreeDto() {
        //     // 获取权限设定
        //     this.limits = JSON.parse(sessionStorage.getItem('limit'))
        //     const params = this.limits.buttonTreeDto.filter(
        //         (item) => item.menuCode === 'role'
        //     )
        //     params[0].buttonList.forEach((item) => {
        //         this.parArray.push(item.code)
        //     })
        //     console.log(this.parArray)
        // },
        fetchData() {
            const params = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize
            }
            this.$api.updatesList(params).then((res) => {
                if (res.code === 0) {
                    this.tableList = res.data.list
                    this.page.totalNum = res.data.totalNum
                }else{
                    this.tableList = []
                    this.page.totalNum = 0
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        onDelete(item){
             const params =[item.id]
            this.$api.updatesDelete(params).then((res) => {
                if (res.code === 0) {
                    this.page.pageNo = 1
                    this.fetchData()
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        handleCurrentChange(currentChange) {
            this.page.pageNo = currentChange
            this.fetchData()
        },
        handleSizeChange(sizeChange) {
            this.page.pageSize = sizeChange
            this.fetchData()
        },


        openAdiog() {
            this.dialogFormVisible = true;
            this.form = {
                version: "",
                wgtUrl: "",
                updateTips: ""
            };
            this.fileList = []
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },

        //确认新增
        updateOk() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.btnloading = true;
                    console.log('>>',this.form)
                    this.$api.updatePackage(this.form).then((res) => {
                    if (res.code === 0) {
                        this.page.pageNo = 1
                    }
                }).finally(() => {
                    this.dialogFormVisible = false
                    this.btnloading = false
                    this.fetchData()
                })
                }
            })

        },
        getUrl(url){
            this.form.wgtUrl = url
            this.$refs.form.validateField('wgtUrl');
        }
    }
}
</script>

<style scoped lang="scss">
.data-title {
    width: 100%;
    height: 32px;
    margin-top: 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-line {
        width: 2px;
        height: 16px;
        background: #00B498;
        border-radius: 0px 0px 0px 0px;
        margin-top: 8px;
    }

    .title-name {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #2F3030;
        margin-left: 4px;
        line-height: 32px;
    }

    .title-btn {
        display: flex;

        .title-btn-item {
            width: 110px;
            height: 32px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #E3E6E5;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 8px;
            padding-right: 8px;
            box-sizing: border-box;
            cursor: pointer;

            .btn-l {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #2F3030;

            }
        }


    }
}


.content {
    padding: 32px 16px 16px;
    background-color: #ffffff;
    min-height: calc(100vh - 118px);
    box-sizing: border-box;
    border-bottom: 32px solid #F5FAF9;
    border-radius: 8px 8px 8px 8px / 8px 8px 40px 40px;

    h3 {
        position: relative;
        margin-bottom: 20px;
        padding-left: 10px;

        &:before {
            position: absolute;
            top: 5px;
            left: 0;
            display: inline-block;
            content: "";
            width: 3px;
            height: 20px;
            background-color: #00B498;
        }
    }

    h4 {
        padding-top: 10px;
        border-top: 1px solid #bbbbbb;
    }
}
.elForm {
    padding: 20px 10px;
    /deep/{
        .el-input__inner,
        .el-textarea__inner{ 
            padding-left: 8px;
        }
        .el-form-item__label{
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
        }
    }
    
}
.upload-file-con /deep/{
    .el-form-item__content{
        line-height: 1;
    }
    .el-upload-list__item:first-child{
        margin-top: 0;
    }
    .el-upload-list__item-name{
        text-align: left;
    }
}
.update-app /deep/{
     .el-dialog__body{
        padding-bottom: 0;
    }
    .el-dialog__footer{
        padding-bottom: 30px;
    }
    .el-upload-list__item{
        transition: none;
    }
}
</style>